import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return <div className="bg-dark p-3 text-white text-center">footer</div>;
  }
}
